import { noop } from 'lodash';
import callOrLog from '../../../constants/callOrLog';
export function initiateSocialCoverageEventTracking(_ref) {
  var _ref$eventTracker = _ref.eventTracker,
    eventTracker = _ref$eventTracker === void 0 ? noop : _ref$eventTracker,
    _ref$eventName = _ref.eventName,
    eventName = _ref$eventName === void 0 ? '' : _ref$eventName;
  callOrLog(function () {
    return eventTracker(eventName, {
      insurance_types: ['social']
    });
  });
}
//# sourceMappingURL=initiateSocialCoverageEventTracking.js.map